export default (() => {
    
    const addressToCoordinates = (address) => {

        var geocoder = new google.maps.Geocoder();

        return new Promise((resolve, reject) => {

            geocoder.geocode({'address': address}, (results, status) => {

                if (status == 'OK' && results.length > 0) {

                    const location = results[0].geometry.location;

                    resolve({
                        lat: parseFloat(location.lat()),
                        lng: parseFloat(location.lng())
                    });

                } else {

                    reject('A location could not be found for this address.');
                }
            });
        });
    };

    return {
        addressToCoordinates
    };
    
})()


// WEBPACK FOOTER //
// ./services/geocoder.js